<template>
    <div id="print" v-if="!isEmpty(listProgramWordGame)" class="question_content" @touchmove="touchmove"
         :style="{'background-color': '#CA80B1'}">

        <audio v-show="false" :src="clInitUrl" id="cl_init_audio"/>
        <audio v-show="false" :src="clHintUrl" id="cl_hint_audio"/>

        <div v-if="showExitConfirm === 1" class="exit_transition">
            <div class="exit_content">
                <div class="exit_title">还没有完成，确认要放弃吗？</div>
                <div class="game_action">
                    <div class="game_quit" v-on:click.stop="gameQuitClick">
                        <img src="../../Images/game_quit.png"/>
                        <span>Quit</span>
                    </div>
                    <div class="game_continue" v-on:click.stop="gameContinueClick">
                        <img src="../../Images/game_continue.png"/>
                        <span>Continue</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="transition" v-if="showTransition">
            <div class="back_nav2" v-on:click.stop="gameQuitClick"><img src="../../assets/back_nav.png"/></div>
            <div class="content">
                <div class="content2">
                    <img class="icon" src="@/Images/jili.png"/>
                    <div id="id_star_count" class="text">
                        <span class="success_tip">祝贺完成!</span>
                    </div>
                    <div class="content3">
                        <div class="transition_comeback" v-on:click.stop="gameQuitClick">
                            <img src="../../Images/transition_comeback.png"/>
                        </div>
                        <div class="transition_next" v-on:click.stop="nextPageClick">
                            <span>拓展</span>
                            <img src="../../assets/chevron-thin-right.png"/>
                        </div>
                    </div>
                </div>
            </div>
            <audio class="audio" :src="greatAudio" id="great_audio"/>
        </div>

        <div class="star_transition" v-if="showStarTransition && starCount > 0">
            <div class="content">
                <div class="content2">
                    <div class="star_show">
                        <div class="icon1"><img id="star_img_1" style="display: none" :src="getStarImg(1)"/></div>
                        <div class="icon2"><img id="star_img_2" style="display: none" :src="getStarImg(2)"/></div>
                        <div class="icon3"><img id="star_img_3" style="display: none" :src="getStarImg(3)"/></div>
                    </div>
                    <div class="star_score">
                        <img class="icon" src="@/assets/star_score_s.png"/><span>+{{starCount}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="star_animation" style="display:none">
            <div class="star_score">
                <img class="icon" src="@/assets/star_score_s.png"/><span>+{{starCount}}</span>
            </div>
        </div>
        <div class="score_content" :style="{top: '20px', right: '30px', display:'none'}"><img src="../../assets/star_score_s.png"/><span>{{totalStarCount}}</span></div>
        <audio class="audio" :src="starAudio" id="star_audio" @ended="playEnded('star_audio')" @error="playEnded('star_audio')" />

        <div class="back_nav" @click="backNav()"><img src="../../assets/back_nav.png"/></div>
        <div class="connectline_question_content">
            <div class="connectline_imgs" :style="{width:currentProgramWordGame.wordPictureList.length * 110 + 'px'}">
                <div class="img_item" :id="'cl_imgitem' + indexOption"  v-for="(itemOption,indexOption) in currentProgramWordGame.wordPictureList"
                     :key="'img_' + indexOption" @click="imgClick(indexOption)">
                    <img :src="geneNetworkPicture(itemOption.picture)" alt=""/>
                    <div class="img_item_point" style="display: none">
                        <div class="point"></div>
                        <span :id="'imgitem_ripple_one' + indexOption"></span>
                        <span :id="'imgitem_ripple_two' + indexOption"></span>
                    </div>
                    <div class="img_item_mantle" style="display: none"></div>
                </div>
            </div>
            <div  class="bubbleContainer2" v-if="noShowChoiceGuide1 === 0" :style="{top:'128px', left:currentProgramWordGame.wordPictureList.length%2 === 0 ? 'calc(50% - 120px)' : '50%', '-webkit-transform':currentProgramWordGame.wordPictureList.length%2 === 0 ? '' : 'translateX(-50%)'}" @click="guide1Click">
                <div class="text">第1步  点击图片</div>
                <div class="img"><img src="../../assets/play_arrow_up.png"/></div>
            </div>
            <div class="bubbleContainer2" v-if="noShowChoiceGuide2 === 0" :style="{bottom:'122px', left:currentProgramWordGame.wordPictureList.length%2 === 0 ? 'calc(50% - 125px)' : '50%', '-webkit-transform':currentProgramWordGame.wordPictureList.length%2 === 0 ? '' : 'translateX(-50%)'}" @click="guide2Click">
                <div class="text">第2步  再点击图片</div>
                <div class="img" style="bottom:-4px;top:auto"><img src="../../assets/play_arrow.png"/></div>
            </div>
            <div class="connectline_words" :style="{width:currentProgramWordGame.onlyWordList.length * 110 + 'px'}">
                <div class="cl_worditem" :id="'cl_worditem' + indexOption" v-for="(itemOption,indexOption) in currentProgramWordGame.onlyWordList" :key="'word_' + indexOption" @click="wordClick(indexOption)">
                    <img :src="geneNetworkPicture(itemOption.picture)" alt=""/>
<!--                    <div class="cl_worditem_content">-->
<!--                        <span>{{itemOption.word}}</span>-->
<!--                    </div>-->
                    <div class="cl_worditem_point" style="display: none">
                        <div class="point"></div>
                        <span :id="'worditem_ripple_one' + indexOption"></span>
                        <span :id="'worditem_ripple_two' + indexOption"></span>
                    </div>
                    <div class="cl_worditem_mantle" style="display: none"></div>
                </div>
            </div>
            <canvas class="connectline_canvas" id="myCanvas"/>
            <audio :src="lfAudioUrl" id="lf_musicMp3" style="display:none" @ended="lf_playCEnded" @error="lf_playCEnded"
                   controls=""/>
            <div id="id_choice_guide" v-if="noShowChoiceGuide1 === 0" @click="guide1Click" class='popContainer3' :style="{top:'40px', left:currentProgramWordGame.wordPictureList.length%2 === 0 ? 'calc(50% - 90px)' : 'calc(50% - 35px)'}">
                <img  src="../../assets/click.png" alt=""/></div>
            <div id="id_choice_guide2" v-if="noShowChoiceGuide2 === 0" @click="guide2Click" class='popContainer3' :style="{bottom:'40px', left:currentProgramWordGame.wordPictureList.length%2 === 0 ? 'calc(50% - 90px)' : 'calc(50% - 35px)'}">
                <img  src="../../assets/click.png" alt=""/></div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";
    import Utils from "@/pages/Program/util2";

    function transformView() {
        var width = document.documentElement.clientWidth;
        var height = document.documentElement.clientHeight;

        var vPrint =  $('#print');
        if( width > height ){
            //竖屏
            vPrint.width(width);
            vPrint.height(height);
            vPrint.css('top', 0);
            vPrint.css('left', 0);
            vPrint.css('transform' , 'none');
            vPrint.css('transform-origin' , '50% 50%');
        }
        else{
            //横屏
            vPrint.width(height);
            vPrint.height(width);
            vPrint.css('top',  (height-width)/2 );
            vPrint.css('left',  0-(height-width)/2 );
            vPrint.css('transform' , 'rotate(90deg)');
            vPrint.css('transform-origin' , '50% 50%');
        }
    }

    export default {
        data() {
            return {
                // 拖拽题
                lessonId: 0,
                currentIndex: 0,
                objMathStartExercises:null,
                listProgramWordGame:[],
                currentProgramWordGame:{},
                showExitConfirm: 0,
                // 连线题存储的值
                checkedImgIndex:-1,
                checkedWordIndex:-1,
                successArray:[],
                lfAudioUrl: "",
                clInitUrl: "",
                clHintUrl: "",
                showTransition: false,
                greatAudio:"https://img.xiaohuasheng.cn/great.mp3",
                noShowChoiceGuide1:1,
                noShowChoiceGuide2:1,
                starAudio:null,
                starCount:0,
                showStarTransition:false,
                totalStarCount:0,
                connectLineError:0,
                finishQuestion:0,
                hasExit: false,
            }
        },
        methods:{
            getStarImg(count) {
                let that = this;
                return count <= that.starCount ? require('@/assets/star_score_s.png') : require('@/assets/star_score_n.png');
            },
            backQuestionForLeftClick() {
                let that = this;
                that.currentIndex -= 1;

                if (that.currentIndex < 0) {
                    return;
                }

                that.nextQuestionPostClick();
            },
            nextQuestionClick:function() {
                let that = this;
                that.currentIndex += 1;
                that.nextQuestionPostClick();
            },
            nextQuestionPostClick:function() {
                let that = this;

                if (that.currentIndex >= that.listProgramWordGame.length) {
                    if (!that.isEmpty(that.objMathStartExercises.mindmapQuestion)) {
                        // 最后一道题
                        setTimeout(() => {
                            this.$router.replace({
                                name: 'MPractice', query: {lessonId: this.lessonId, modeType:1}
                            });
                        }, 500);
                    } else {
                        // 增加过度界面
                        that.showFinishTransition();
                    }

                    return;
                }

                that.checkedImgIndex = -1;
                that.checkedWordIndex = -1;
                that.successArray = [];
                that.lfAudioUrl = "";
                that.finishQuestion = 0;

                setTimeout(() => {
                    let initAudio = document.getElementById('cl_init_audio');
                    initAudio.play();
                }, 10);

                let myCanvas = document.getElementById("myCanvas");
                let ctx = myCanvas.getContext("2d");
                ctx.clearRect(0,0, myCanvas.width, myCanvas.height);

                that.currentProgramWordGame = that.listProgramWordGame[that.currentIndex];

                setTimeout(() => {
                    var myCanvas = document.getElementById("myCanvas");
                    let divPrint = document.getElementById('print');

                    myCanvas.width = that.currentProgramWordGame.wordPictureList.length * 110;
                    myCanvas.height = divPrint.clientHeight - 249;
                }, 20);
            },
            nextPageClick:function () {
                let that = this;
                Utils.$emit('setFinishPart', that.lessonId, 4);

                this.$router.replace({
                    name: 'MExpansion', query: {lessonId: this.lessonId}
                });
            },
            closeTransition() {
                this.closePage();
            },
            closePage: function () {
                this.showTransition = false;
                this.hasExit = true;
                this.$router.go(-1);
            },
            getClickIndex() {
                let shang = parseInt(this.currentProgramWordGame.wordPictureList.length/2);
                let yuShu = this.currentProgramWordGame.wordPictureList.length%2;
                return shang + yuShu - 1;
            },
            guide1Click() {
                this.guidePostClick(1);
                let vIndex = this.getClickIndex();
                this.imgClick(vIndex);
            },
            guide2Click() {
                this.guidePostClick(2);
                let vIndex = this.getClickIndex();
                this.wordClick(vIndex);
            },
            guidePostClick:function(type){
                let that = this;

                if (that.noShowChoiceGuide1 === 1 && that.noShowChoiceGuide2 === 1) {
                    return;
                }

                if (that.noShowChoiceGuide1 === 1 || that.noShowChoiceGuide2 === 1) {
                    that.noShowChoiceGuide1 = 1;
                    that.noShowChoiceGuide2 = 1;
                    return;
                }

                that.$axios.get("mathStart/saveGuidePrompt/key11").then((response) => {
                    let vResult = that.getCount(response.data);

                    if (vResult === 1) {
                        if (type === 1) {
                            that.noShowChoiceGuide1 = 1;
                        } else {
                            that.noShowChoiceGuide2 = 1;
                        }
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            showFinishTransition() {
                let that = this;
                that.showTransition = true;
                Utils.$emit('setStarCount','4');
            },
            finishThis:function() {
                let that = this;

                setTimeout(() => {
                    // 下一步
                    that.successGetStarToNext();
                }, 1500);
            },
            successGetStarToNext() {
                let that = this;
                if (that.finishQuestion !== 1) {
                    that.finishQuestion = 1;
                    that.connectLineError = 0;

                    // 过3.5秒跳转到下一步
                    setTimeout(function () {
                        $(".cl_worditem_mantle").css("display", "none");
                        $(".img_item_mantle").css("display", "none");

                        if (!that.hasExit) {
                            that.nextQuestionClick();
                        }

                    }, 1000);
                }
            },
            playEnded(idMusicmp3) {
                var musicMp3 = document.getElementById(idMusicmp3);

                if (musicMp3 != null) {
                    musicMp3.pause();
                }
            },
            lf_playCEnded() {
                let that = this;
                that.playEnded('lf_musicMp3');
            },
            imgClickSytle(currentIndex, hasSelected) {
                let that = this;

                $(".connectline_question_content .connectline_imgs .img_item").each(function (idex, item) {
                    let vImgItem = that.currentProgramWordGame.wordPictureList[idex];

                    if (!that.judgeConnectLine(that.successArray, vImgItem.word)) {
                        $(item).css("opacity", idex === currentIndex ? "1" : "0.5");
                        $(item).find(".img_item_point").css("display", idex === currentIndex ? "block" : "none");
                        $("#imgitem_ripple_one" + idex).removeClass("cl_worditem_point_ripple1");
                        $("#imgitem_ripple_two" + idex).removeClass("cl_worditem_point_ripple2");
                    }
                });

                $(".connectline_question_content .connectline_words .cl_worditem").each(function (idex, item) {
                    let vWordItem = that.currentProgramWordGame.onlyWordList[idex];

                    if (!that.judgeConnectLine(that.successArray, vWordItem.word)) {
                        if (!hasSelected) {
                            $(item).find(".cl_worditem_point").css("display", "block");
                            $("#worditem_ripple_one" + idex).addClass("cl_worditem_point_ripple1");
                            $("#worditem_ripple_two" + idex).addClass("cl_worditem_point_ripple2");
                        }
                    }
                });
            },
            clearClickSytle() {
                let that = this;

                $(".connectline_question_content .connectline_imgs .img_item").each(function (idex, item) {
                    let vImgItem = that.currentProgramWordGame.wordPictureList[idex];

                    if (!that.judgeConnectLine(that.successArray, vImgItem.word)) {
                        $(item).css("opacity", "1");
                        $(item).find(".img_item_point").css("display", "none");
                        $("#imgitem_ripple_one" + idex).removeClass("cl_worditem_point_ripple1");
                        $("#imgitem_ripple_two" + idex).removeClass("cl_worditem_point_ripple2");
                    }
                });

                $(".connectline_question_content .connectline_words .cl_worditem").each(function (idex, item) {
                    let vWordItem = that.currentProgramWordGame.onlyWordList[idex];

                    if (!that.judgeConnectLine(that.successArray, vWordItem.word)) {
                        $(item).find(".cl_worditem_point").css("display", "none");
                        $("#worditem_ripple_one" + idex).removeClass("cl_worditem_point_ripple1");
                        $("#worditem_ripple_two" + idex).removeClass("cl_worditem_point_ripple2");
                    }
                });
            },
            imgClick:function(index) {
                // 判断是否已经连线
                let that = this;
                this.guidePostClick(1);
                let vImgItem = that.currentProgramWordGame.wordPictureList[index];

                if (that.judgeConnectLine(this.successArray, vImgItem.word)) {
                    return;
                }

                that.checkedImgIndex = index;
                // 展示选中效果
                that.imgClickSytle(index, that.checkedWordIndex !== -1);

                // 没有选中单词，只选中了图片不进行连线
                if (that.checkedWordIndex === -1) {
                    that.playMusicMp3(vImgItem.audio);
                    return;
                }

                let vWordItem = that.currentProgramWordGame.onlyWordList[that.checkedWordIndex];
                let vCount = that.currentProgramWordGame.wordPictureList.length;

                // 判断连线是否正确
                if (vImgItem.word === vWordItem.word) {
                    // 播放正确音效
                    that.playHintMp3("success.mp3");

                    // 播放音频
                    setTimeout(() => {
                        that.playMusicMp3(vImgItem.audio);
                    }, 800);

                    // 如果正确进行存储
                    that.connectLine(that.checkedImgIndex, that.checkedWordIndex, vCount, "#FED900", vImgItem.word);
                    that.clearClickSytle();

                    $("#cl_imgitem" + index).find(".img_item_mantle").css("display", "block");
                    $("#cl_worditem" + that.checkedWordIndex).find(".cl_worditem_mantle").css("display", "block");

                    $("#worditem_ripple_one" + that.checkedWordIndex).removeClass("cl_worditem_point_ripple1");
                    $("#worditem_ripple_two" + that.checkedWordIndex).removeClass("cl_worditem_point_ripple2");

                    if (that.successArray.length === that.currentProgramWordGame.wordPictureList.length) {
                        that.finishThis();
                    }
                } else {
                    // 播放错误音效
                    that.playHintMp3("error_tip.mp3");

                    // 如果不正确，去掉连线
                    that.connectLine(that.checkedImgIndex, that.checkedWordIndex, vCount, "red", "");

                    // 清除线条，重新绘制线条
                    setTimeout(() => {
                        that.clearClickSytle();
                        that.redrawConnectLine();
                    }, 500);

                    that.connectLineError += 1;
                }

                setTimeout(() => {
                    // $("#cl_imgitem" + that.checkedImgIndex).css("border", "3px solid white");
                    // $("#cl_worditem" + that.checkedWordIndex).css("border", "3px solid white");

                    that.checkedImgIndex = -1;
                    that.checkedWordIndex = -1;
                }, 500);
            },
            playMusicMp3:function(audio) {
                let lfmusicMp3 = document.getElementById('lf_musicMp3');
                lfmusicMp3.src = "https://img.xiaohuasheng.cn/" + audio;
                lfmusicMp3.play();
            },
            playHintMp3: function (audio) {
                let hintAudio = document.getElementById('cl_hint_audio');
                hintAudio.src = "https://img.xiaohuasheng.cn/" + audio;
                hintAudio.play();
            },
            wordClickSytle(currentIndex, hasSelected) {
                let that = this;

                $(".connectline_question_content .connectline_imgs .img_item").each(function (idex, item) {
                    let vImgItem = that.currentProgramWordGame.wordPictureList[idex];

                    if (!that.judgeConnectLine(that.successArray, vImgItem.word)) {
                        if (!hasSelected) {
                            $(item).find(".img_item_point").css("display", "block");
                            $("#imgitem_ripple_one" + idex).addClass("cl_worditem_point_ripple1");
                            $("#imgitem_ripple_two" + idex).addClass("cl_worditem_point_ripple2");
                        }
                    }
                });

                $(".connectline_question_content .connectline_words .cl_worditem").each(function (idex, item) {
                    let vWordItem = that.currentProgramWordGame.onlyWordList[idex];

                    if (!that.judgeConnectLine(that.successArray, vWordItem.word)) {
                        $(item).find(".cl_worditem_point").css("display", idex === currentIndex ? "block" : "none");
                        $("#worditem_ripple_one" + idex).removeClass("cl_worditem_point_ripple1");
                        $("#worditem_ripple_two" + idex).removeClass("cl_worditem_point_ripple2");
                    }
                });
            },
            wordClick:function(index) {
                let that = this;
                this.guidePostClick(2);
                let vWordItem = that.currentProgramWordGame.onlyWordList[index];

                if (that.judgeConnectLine(that.successArray, vWordItem.word)) {
                    return;
                }

                that.checkedWordIndex = index;

                // 展示选中效果
                that.wordClickSytle(index, that.checkedImgIndex !== -1);

                // 没有选中图片，只选中了单词不进行连线
                if (that.checkedImgIndex === -1) {
                    that.playMusicMp3(vWordItem.audio);
                    return;
                }

                let vImgItem = that.currentProgramWordGame.wordPictureList[that.checkedImgIndex];
                let vCount = that.currentProgramWordGame.onlyWordList.length;

                // 判断连线是否正确
                if (vImgItem.word === vWordItem.word) {
                    // 播放正确音效
                    that.playHintMp3("success.mp3");

                    // 播放音频
                    setTimeout(() => {
                        that.playMusicMp3(vWordItem.audio);
                    }, 800);

                    // 如果正确进行存储
                    that.connectLine(that.checkedImgIndex, that.checkedWordIndex, vCount, "#FED900", vImgItem.word);
                    that.clearClickSytle();

                    $("#cl_worditem" + index).find(".cl_worditem_mantle").css("display", "block");
                    $("#cl_imgitem" + that.checkedImgIndex).find(".img_item_mantle").css("display", "block");

                    $("#imgitem_ripple_one" + that.checkedImgIndex).removeClass("cl_worditem_point_ripple1");
                    $("#imgitem_ripple_two" + that.checkedImgIndex).removeClass("cl_worditem_point_ripple2");

                    if (that.successArray.length === that.currentProgramWordGame.onlyWordList.length) {
                        that.finishThis();
                    }
                } else {
                    // 播放错误音效
                    that.playHintMp3("error_tip.mp3");

                    // 如果不正确，去掉连线
                    that.connectLine(that.checkedImgIndex, that.checkedWordIndex, vCount, "red", "");

                    // 清除线条，重新绘制线条
                    setTimeout(() => {
                        that.clearClickSytle();
                        that.redrawConnectLine();
                    }, 500);

                    that.connectLineError += 1;
                }

                setTimeout(() => {
                    // $("#cl_imgitem" + that.checkedImgIndex).css("border", "3px solid white");
                    // $("#cl_worditem" + that.checkedWordIndex).css("border", "3px solid white");

                    that.checkedImgIndex = -1;
                    that.checkedWordIndex = -1;
                }, 500);
            },
            judgeConnectLine:function(array, word) {
                let vHasConnect = false;

                if (this.isEmpty(array) || this.isEmpty(word)) {
                    return vHasConnect;
                }

                array.forEach(item => {
                    if (item.word  === word) {
                        vHasConnect = true;
                    }
                });

                return vHasConnect;
            },
            redrawConnectLine:function() {
                let myCanvas = document.getElementById("myCanvas");
                let ctx = myCanvas.getContext("2d");
                ctx.clearRect(0,0, myCanvas.width, myCanvas.height);

                if (this.isEmpty(this.successArray)) {
                    return;
                }

                for (let i = 0; i < this.successArray.length; i++) {
                    let vWordPont = this.successArray[i];
                    this.createConnectLine(vWordPont.imgPointX, vWordPont.wordPointX, "#FED900");
                }
            },
            connectLine:function(imgIndex, wordIndex, count, color, word) {
                let myCanvas = document.getElementById("myCanvas");
                let itemWidth = myCanvas.width/count;
                let vImgPointX = imgIndex*itemWidth + itemWidth/2;
                let vWordPointX = wordIndex*itemWidth + itemWidth/2;

                this.createConnectLine(vImgPointX, vWordPointX, color);

                if (!this.isEmpty(word)) {
                    let vWordPont = {word:word, imgPointX:vImgPointX, wordPointX:vWordPointX};
                    this.successArray.push(vWordPont);
                }
            },
            createConnectLine:function(imgPointX, wordPointX, color) {
                let c = document.getElementById("myCanvas");
                let ctx = c.getContext("2d");

                ctx.beginPath();
                ctx.strokeStyle = color;
                ctx.setLineDash([15, 5]);
                ctx.moveTo(imgPointX, 0);//起始位置
                ctx.lineTo(wordPointX, c.height);//停止位置
                ctx.lineWidth = 3;
                ctx.stroke();
            },
            showStatus:function (status) {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:showStatusView:" + status;
                }

                if (vPlatform === 4) {
                    window.note.showStatusView(status);
                }
            },
            hideStatusAndStopAudio: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:hideStatusAndStopAudio";
                }

                if (vPlatform === 4) {
                    window.note.hideStatusAndStopAudio();
                }
            },
            touchmove(e) {
                e.preventDefault();
            },
            backNav:function(){
                this.showExitConfirm = 1;
            },
            gameQuitClick() {
                this.showExitConfirm = 0;
                this.hasExit = true;
                this.$router.go(-1);
            },
            gameContinueClick() {
                this.showExitConfirm = 0;
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
        },
        beforeCreate() {
            let that = this;
            let vLessonId = parseInt(that.$route.query.lessonId);
            let url = "mathStart/getExercises/" + vLessonId;

            that.$axios.get(url).then((response) => {
                that.objMathStartExercises = response.data;
                that.listProgramWordGame = that.objMathStartExercises.connectLineQuestion;

                that.currentProgramWordGame = that.listProgramWordGame[this.currentIndex];
                that.totalStarCount = parseInt(that.currentProgramWordGame.totalStarCount);
                that.lessonId = vLessonId;
                that.hideStatusAndStopAudio();

                if (that.currentProgramWordGame != null) {
                    that.noShowChoiceGuide1 = that.currentProgramWordGame.key11;
                    that.noShowChoiceGuide2 = that.currentProgramWordGame.key11;
                    that.clInitUrl = that.$qiNiuDomainBase + that.currentProgramWordGame.fixedQuestionAudio;
                }

                setTimeout(() => {
                    transformView();

                    var myCanvas = document.getElementById("myCanvas");
                    let divPrint = document.getElementById('print');

                    myCanvas.width = that.currentProgramWordGame.wordPictureList.length * 110;
                    myCanvas.height = divPrint.clientHeight - 249;
                    //that.showGuide();
                }, 100);

                setTimeout(() => {
                    let initAudio = document.getElementById('cl_init_audio');
                    let playPromise = initAudio.play();

                    if (playPromise !== undefined) {
                        playPromise.then(() => {
                        }).catch((e) => {
                            let vError = JSON.stringify(e);

                            if (!that.isEmpty(vError) && vError !== "{}") {
                                window.console.log("播放初始音失败:" + vError);
                            }
                        });
                    } else {
                        window.console.log("播放初始音失败");
                    }
                }, 500);

            }).catch(function (error) {
                window.console.log(error)
            });
        },
        created() {
            this.$nextTick(() => {
                // 禁用右键
                document.oncontextmenu = new Function("event.returnValue=false");
                // 禁用选择
                document.onselectstart = new Function("event.returnValue=false");
            });
        }
    }
</script>

<style scoped>
    @media screen and (orientation: portrait) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
            overflow: hidden;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: red;
            overflow: hidden;
        }

        #print {
            position: absolute;
            background-color: #f2f2f2;
        }
    }
    @media screen and (orientation: landscape) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        #print {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: #f2f2f2;
        }
    }
    .back_nav {
        position: absolute;
        z-index: 999;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav img {
        width: 30px;
        height: 30px;
    }
    .question_content .exit_transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.9);
        z-index: 1003;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .question_content .exit_content {
        position:relative;
    }
    .question_content .exit_content .exit_title {
        color: white;
        font-size: 18px;
        text-align: center;
        margin-bottom: 50px;
    }
    .question_content .exit_content .game_action .game_quit {
        display: inline-block;
        margin-right: 100px;
    }
    .question_content .exit_content .game_action .game_continue {
        display: inline-block;
    }
    .question_content .exit_content .game_action .game_quit img, .question_content .exit_content .game_action .game_continue img {
        display: block;
        width: 70px;
        margin-bottom: 10px;
    }
    .question_content .exit_content .game_action .game_quit span, .question_content .exit_content .game_action .game_continue span {
        display: block;
        text-align: center;
        font-size: 20px;
        color: white;
    }
    .connectline_question_content {
        position:absolute;
        width: 100%;
        height: 100vmin;
        text-align: center;
    }
    .connectline_question_content .connectline_imgs {
        position:absolute;
        top: 20px;
        left: 50%;
        -webkit-transform: translateX(-50%);
        height: 100px;
    }
    .connectline_question_content .connectline_imgs .img_item {
        position: relative;
        display: inline-block;
        width: 100px;
        height: 106px;
        font-size: 0;
        margin-left: 5px;
        margin-right: 5px;
        -webkit-tap-highlight-color:rgba(0,0,0,0);
    }
    .connectline_question_content .connectline_imgs .img_item img {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        width: 100px;
        height: 100px;
        border-radius: 20px;
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
    }
    .connectline_question_content .connectline_imgs .img_item .img_item_point {
        position: absolute;
        z-index: 1;
        bottom: 0;
        left: 50%;
        -webkit-transform: translateX(-50%);
        width: 10px;
        height: 10px;
    }

    .connectline_question_content .connectline_imgs .img_item .img_item_point .point {
        width: 10px;
        height: 10px;
        background-color: white;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }

    .connectline_question_content .connectline_words {
        position:absolute;
        bottom: 20px;
        left: 50%;
        -webkit-transform: translateX(-50%);
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .connectline_question_content .connectline_words .cl_worditem {
        position: relative;
        width: 100px;
        height: 106px;
        margin-left: 5px;
        margin-right: 5px;
        -webkit-tap-highlight-color:rgba(0,0,0,0);
    }
    .connectline_question_content .connectline_words .cl_worditem img {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        width: 100px;
        height: 100px;
        border-radius: 20px;
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
    }
    .connectline_question_content .connectline_words .cl_worditem .cl_worditem_content {
        position: absolute;
        bottom: 0;
        width: 100px;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: white;
        border-radius: 20px;
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
        font-size: 18px;
        font-weight: bold;
    }
    .connectline_question_content .connectline_words .cl_worditem .cl_worditem_content span {
        display: inline-block;
        line-height: 20px;
    }
    .connectline_question_content .connectline_words .cl_worditem .cl_worditem_point {
        position: absolute;
        z-index: 1;
        top: 0;
        left: 50%;
        -webkit-transform: translateX(-50%);
        width: 10px;
        height: 10px;
    }
    .connectline_question_content .connectline_words .cl_worditem .cl_worditem_point .point {
        width: 10px;
        height: 10px;
        background-color: white;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }
    @keyframes living {
        0%{
            transform: scale(1);
            opacity: 0.5;
        }
        50%{
            transform: scale(2.5);
            opacity: 0;   /*圆形放大的同时，透明度逐渐减小为0*/
        }
        100%{
            transform: scale(1);
            opacity: 0.5;
        }
    }
    .cl_worditem_point_ripple1 {
        position: absolute;
        width: 10px;
        height: 10px;
        left: 0;
        bottom: 0;
        background: #fff;
        border-radius: 50%;
        -webkit-animation: living 3s linear infinite;
        z-index: -1;
    }
    .cl_worditem_point_ripple2 {
        -webkit-animation-delay: 1.5s; /*第二个span动画延迟1.5秒*/
    }

    .img_item_mantle {
        position: absolute;
        z-index: 3;
        top: 0;
        background-color: #24B76F30;
        width: 100px;
        height: 100px;
        border-radius: 20px;
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
    }
    .cl_worditem_mantle {
        position: absolute;
        z-index: 3;
        top: 6px;
        background-color: #24B76F30;
        width: 100px;
        height: 100px;
        border-radius: 20px;
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
    }
    .connectline_question_content .connectline_canvas {
        position:absolute;
        left: 50%;
        -webkit-transform: translateX(-50%);
        top:126px;
    }
    .next_question {
        position:absolute;
        z-index: 999;
        width: 120px;
        height: 40px;
        bottom: 30px;
        background-color:#06A846;
        display: flex;
        align-items: center;
        border-radius: 20px;
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
        animation: zoom 1s infinite;
    }
    .next_question .next_question_c {
        margin-left: 20px;
        display: inline-block;
    }
    .next_question .next_question_c span {
        display: inline-block;
        color: white;
        margin-right: 5px;
        font-weight: bold;
        vertical-align: middle;
    }
    .next_question .next_question_c img {
        display: inline-block;
        width: 30px;
        height: 30px;
        vertical-align: middle;
    }
    @keyframes zoom {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.1);
        }
        100% {
            transform: scale(1);
        }
    }
    .question_content .transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.85);
        z-index: 1002;
    }
    .question_content .transition .content {
        position: relative;
        z-index: 1001;
        width: 100%;
        height: 100vmin;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .question_content .transition .content2 {
        text-align: center;
    }

    .question_content .transition .content3 {
        text-align: center;
    }
    .question_content .transition .content .icon {
        margin-bottom: 10px;
        width: 35%;
    }
    .question_content .transition .content .text {
        width: 100%;
        margin-top: 5px;
    }
    .question_content .transition .content .text span {
        display: block;
        text-align: center;
    }
    .question_content .transition .content .text .success_tip {
        font-size: 24px;
    }
    .question_content .transition .content .star {
        height: 35px;
    }
    .question_content .transition .content .star .star_item {
        width: 35px;
        height: 35px;
        display: inline-block;
        position: relative;
    }
    .question_content .transition .content .star .star_item img {
        width: 35px;
        height: 35px;
        display: none;
        position: absolute;
        left:50%;
        top: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }
    .question_content .transition .content .text span {
        width: 100%;
        color: white;
        font-size: 12px;
    }
    .transition_next {
        margin-top: 30px;
        display: inline-block;
        background-color: #07A745;
        width: 120px;
        height: 40px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        vertical-align: middle;
        animation: zoom 1s infinite;
        text-align: center;
    }
    .transition_next span {
        display: inline-block;
        font-size: 16px;
        color: white;
        line-height: 39px;
        vertical-align: middle;
    }
    .transition_next img {
        display: inline-block;
        width: 15px;
        vertical-align: middle;
    }
    @keyframes zoom {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.1);
        }
        100% {
            transform: scale(1);
        }
    }
    @keyframes zoom1 {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.3);
        }
        100% {
            transform: scale(1);
        }
    }
    .transition_comeback {
        margin-top: 30px;
        margin-right: 25px;
        display: inline-block;
        text-align: center;
        vertical-align: middle;
        font-size: 0;
    }
    .transition_comeback img {
        display: inline-block;
        width: 40px;
        height: 40px;
    }
    .back_nav2 {
        position: absolute;
        z-index: 1003;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav2 img {
        width: 30px;
        height: 30px;
    }

    .bubbleContainer2{
        position: absolute;
        padding-bottom: 6px;
    }
    .bubbleContainer2 .text {
        color: white;
        background-color: #fda228;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        padding: 3px 10px 3px 10px;
        font-size: 15px;
        font-weight: bold;
    }
    .bubbleContainer2 .img {
        position: absolute;
        top: -12px;
        width: 12px;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }
    .bubbleContainer2 .img img {
        width: 12px;
    }
    .popContainer3 {
        position: absolute;
        z-index: 1000;
        animation: zoom1 1s infinite;
        width: 70px;
        height: 70px;
    }
    .popContainer3 img {
        width: 100%;
        height: 100%;
    }

    img { pointer-events: none; }

</style>
